import { OPERATOR_PATH, PROFILE_PATH, SITE_DESIGNER_PATH } from "./authRouting.js";

export function shouldCheckCurrentUser(route, pathname) {
  return route === "studio" || route === "operator" || route === "profile"
    || pathname === OPERATOR_PATH || pathname === PROFILE_PATH || pathname === SITE_DESIGNER_PATH;
}
